import AppRouter from './components/AppRouter'

function App(param) {
    //console.log(process.env.REACT_APP_ENVIRONMENT)
    return <AppRouter username={param.username} email={param.email}/>;
}

export default App;
